







































import {Vue, Component} from 'vue-property-decorator';
import {GetAddressRequest, OriginalAddress} from 'supporter';
import {Grid} from '@toast-ui/vue-grid';
import {popupResize} from '@/utils/ncp';

import TuiGrid from 'tui-grid';
@Component({components: {Grid}})
export default class AddressPopup extends Vue {
  private keyword: string = '';
  private addresses: OriginalAddress[] = [];
  private totalCount = 0;
  private afterCall: boolean = false;
  private callback = '';
  private created() {
    if (this.$route.query.hasOwnProperty('keyword')) {
      this.keyword = this.$route.params.keyword;
      this.fetchAddresses();
    }
    if (this.$route.query.hasOwnProperty('dataCallback')) {
      this.callback = this.$route.query.dataCallback as string;
    }
    let noData = this.$t('ADDRESS_POPUP_NOT_DATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
  }
  mounted() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination');
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (ev: any) => {
        this.fetchAddresses(ev.page);
        ev.stop();
      });
    }

    grid.invoke('on', 'mousedown', (ev: any) => {
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });
    this.$nextTick(() => {
      popupResize(550, 880);
    });
  }

  private fetchAddresses(page: number = 1): void {
    if (!this.keyword) {
      alert(this.$t('ADDRESS_POPUP_ALERT_MSG'));
      return;
    }
    let requset: GetAddressRequest = {
      params: {
        keyword: this.keyword,
        page: page,
        pageSize: this.gridProps.options.pageOptions.perPage
      }
    };
    this.$api.getAddress(requset).then(res => {
      this.addresses = res.data.items;
      this.totalCount = res.data.totalCount;
      const grid = this.$refs.tuiGrid as Grid;
      const pagination = grid.invoke('getPagination') as any;
      if (pagination) {
        const pageState = {
          totalCount: this.totalCount,
          page: this.gridProps.options.pageOptions.page,
          perPage: this.gridProps.options.pageOptions.perPage
        };
        grid.invoke('resetData', this.addresses as any, {pageState});
      } else {
        grid.invoke('resetData', this.addresses as any);
      }
    });
  }
  private select(ev: any) {
    let addresse = this.addresses[ev.rowKey];
    if (addresse) {
      addresse = this.addField(addresse);
      $(window.opener.location).attr('href', `javascript:${this.callback}(${JSON.stringify(addresse)});`);
      window.close();
    }
  }
  addField(addresse: OriginalAddress): any {
    const temp: any = addresse;
    temp.isJibunSelected = !!addresse.jibunAddress;
    temp.zipCd = addresse.zipCode;
    temp.streetAddress = addresse.roadAddress;
    temp.streetAddressExtra = addresse.roadAddressExtra;
    return temp;
  }
  private gridProps = {
    options: {
      header: {
        height: 0
      },
      rowHeight: 80,
      minBodyHeight: 250,
      bodyHeight: 400,
      minRowHeight: 80,
      pageOptions: {
        visiblePages: 5,
        perPage: 10,
        page: 1,
        totalCount: 0
      }
    },
    columns: [
      {
        header: 'zipCode',
        name: 'zipCode',
        align: 'left',
        minWidth: 180,
        formatter(data: any) {
          const {row} = data;
          return `<div class="address_wrap">
                    <div class="address">
                      <span class="address_tag">${window.$t('ADDRESS_POPUP_ZIP_CODE')}</span>${row.zipCode}
                    </div>
                    <div class="address">
                      <span class="address_tag">${window.$t('ADDRESS_POPUP_ROAD_NAME')}</span>${row.roadAddress} ${row.roadAddressExtra}
                    </div>
                    <div class="address">
                      <span class="address_tag">${window.$t('ADDRESS_POPUP_NUMBER')}</span>${row.jibunAddress}
                    </div>
                  </div>`;
        }
      }
    ]
  };
  private beforeDestroy(): void {
    let noData = this.$t('COMMON_RESULT_NONE') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
  }
}
